var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup62(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.162,
    height: 38.536,
    viewBox: "0 0 46.162 38.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f98b88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8706a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(-164.838 -252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M4.361,20.868a1.247,1.247,0,1,1,0,2.494H1.247a1.245,1.245,0,1,1,0-2.491H4.361v0Zm3-8.708a1.244,1.244,0,0,1-1.24,2.156L3.426,12.761a1.244,1.244,0,1,1,1.24-2.156L7.359,12.16Zm6.957-6.044A1.246,1.246,0,0,1,12.16,7.363L10.605,4.67a1.246,1.246,0,1,1,2.156-1.247l1.555,2.694Zm25.729,8.2a1.244,1.244,0,0,1-1.24-2.156L41.5,10.605a1.244,1.244,0,1,1,1.24,2.156l-2.694,1.555ZM34.005,7.363a1.246,1.246,0,1,1-2.156-1.247L33.4,3.422A1.246,1.246,0,1,1,35.561,4.67L34.005,7.363Zm-8.708-3a1.247,1.247,0,1,1-2.494,0V1.247a1.247,1.247,0,1,1,2.494,0V4.361Zm16.507,19a1.247,1.247,0,0,1,0-2.494h3.111a1.247,1.247,0,1,1,0,2.494Z",
    transform: "translate(164.838 252)",
    fill: "#516395",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M40.951,24.77h1.266A11.349,11.349,0,0,1,53.532,36.085V47.558H29.64V36.081A11.342,11.342,0,0,1,40.951,24.77Z",
    transform: "translate(146.333 236.535)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M40.274,50.917h-2.3v-3c0-.838,0-.928,0-1.026-.034-3.2-.064-5.928,2.618-8.719a9.278,9.278,0,0,1,2.641-1.9,30.5,30.5,0,0,0-2.953,14.647Z",
    transform: "translate(141.139 229.355)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M20.632,85.24H48.446a2.387,2.387,0,0,1,2.382,2.382v1.751a2.387,2.387,0,0,1-2.382,2.382H20.632a2.387,2.387,0,0,1-2.382-2.382V87.622a2.387,2.387,0,0,1,2.382-2.382Z",
    transform: "translate(153.443 198.782)",
    fill: "#516395",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup62);
export default __webpack_public_path__ + "static/media/Group 62.11a90f490c7892f6036a5e0e8fa81a4d.svg";
export { ForwardRef as ReactComponent };